import type { ArtistWorkHistory } from '@customTypes/types';
import { TrashIcon } from '@heroicons/react/24/outline';
import { Flex, Space, Text } from '@mantine/core';

import { getDateDifference } from '@/shared/helper/getDateDifference';
import { translate } from '@/shared/i18n/translate';
import { LBLinkButton } from '@/shared/ui-kit/components';

import styles from './PortfolioItemCard.module.css';

type PortfolioItemCardProps = ArtistWorkHistory & {
  onDelete?: () => void;
};

export const PortfolioItemCard = ({
  clubName,
  clubCountry,
  jobRole,
  onDelete,
  startDate,
  endDate,
  untilNow
}: PortfolioItemCardProps) => (
  <div className={styles.container}>
    <Flex align='center' justify='space-between'>
      <Flex direction='column'>
        <Text fw={600}>{clubName}</Text>
        <Space h={8} />
        <Text c='gray' fz={14}>
          {translate(`commons.artistJobs.${jobRole}`)}
        </Text>
        <Space h={4} />
        <Flex align='center' gap={8} justify='space-between'>
          <Text c='gray' fz={14}>
            {clubCountry}
          </Text>
          <Text c='gray' fz={14}>
            {!untilNow
              ? getDateDifference(startDate, endDate)
              : translate('commons.untilNow')}
          </Text>
        </Flex>
      </Flex>
      {/* <ActionIcon variant='transparent'>
        <ChevronRightIcon width={24} />
      </ActionIcon> */}
    </Flex>
    <Space h={16} />
    {onDelete && (
      <LBLinkButton leftsection={<TrashIcon width={18} />} onClick={onDelete}>
        {translate('commons.delete')}
      </LBLinkButton>
    )}
  </div>
);
